export function extract(result, id, locale) {
  if (result) {
    for (let i = 0; i < result.nodes.length; i++) {
      let node = result.nodes[i]
      if (node.id === id && node.node_locale === locale) {
        return node
      }
    }
  }

  return undefined
}